module.exports = "img/flags/GR.f653316.png";